"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, Breadcrumbs } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsBreadcrumb() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Breadcrumb
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            Displays the path to the current resource using a hierarchy of links.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/breadcrumb" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>A basic breadcrumb navigation</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <Breadcrumbs
            items={[
              { label: "Home", href: "/" },
              { label: "Documentation", href: "/docs" },
              { label: "Breadcrumb" },
            ]}
          />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">items</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">BreadcrumbItem[]</td>
                <td className="py-2 text-muted-foreground">Array of breadcrumb items</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">separator</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">ReactNode</td>
                <td className="py-2 text-muted-foreground">Custom separator element</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
